const bank = process.env.BANK

const componentConfig = {
  settingAlert: {
    serviceAlert: () => {
      const supportedBanks = ['NEXIBUSINESS']
      return supportedBanks.includes(bank)
    }
  }
}

export default componentConfig
